/* eslint-disable import/no-anonymous-default-export */
export default {
  colors: {
    black: '#000000',
  },
};
